import { useEffect, useRef, useCallback } from "react";

export const useLongPress = (callback, { delay = 500 } = {}) => {
  const timeoutRef = useRef();
  const targetRef = useRef();

  const start = useCallback(
    (e) => {
      // Ignore right mouse button
      if (e.button === 2) return; 
    
      // Clear any existing timeouts
      clearTimeout(timeoutRef.current);
      // Store event target to check if release happens on same element
      targetRef.current = e.target;

      // Set timeout to trigger callback
      timeoutRef.current = setTimeout(() => callback(e), delay);
    },
    [callback, delay]
  );

  const clear = useCallback((e) => {
    // Check if release is on the original element
    if (e.target !== targetRef.current) return;

    clearTimeout(timeoutRef.current);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
  };
};
